import GenericAPI, { CONTENT_TYPE } from "../GenericApi";
class BusinessDetailsApi extends GenericAPI {

    BUSINESS_DETAILS_ENDPOINT="/api/businessDetail"
    UPDATE_BUSINESS_DETAILS_ENDPOINT="/api/businessDetail/updateBusiness"
    GET_USER_RATING_ENDPOINT="/api/userRating"


    async getCategoryKeywordList() {
        return this.get(this.BUSINESS_DETAILS_ENDPOINT, {}, true);
    }
    async getBusinessDetails(userId) {
        const payload =  {
            userId
        }
        return this.get(this.BUSINESS_DETAILS_ENDPOINT, payload, true);
    }
    

    async addBusinessDetails(data) {
        return this.post(this.BUSINESS_DETAILS_ENDPOINT, data, CONTENT_TYPE.URLENCODED, true);
    }

    async updateBusinessDetails(data) {
        return this.put(this.UPDATE_BUSINESS_DETAILS_ENDPOINT, data, CONTENT_TYPE.MULTIPART, true);
    }
    async updateBusinessService(data) {
        return this.put(this.BUSINESS_DETAILS_ENDPOINT, data, CONTENT_TYPE.URLENCODED, true);
    }

    async getUserRating(supplierId) {
        const payload =  {
            supplierId
        }
        return this.get(this.GET_USER_RATING_ENDPOINT, payload, true);
    }
}

export default new BusinessDetailsApi();
